import React from 'react';
import styled from 'styled-components';
import { tokens } from '../../config/themeTokens';

const StyledHeading = styled.h2`
  font-family: ${tokens.typography.fontFamilyHeading};
  font-weight: ${tokens.typography.weightBold};
  color: ${tokens.colors.text};
  margin: 0 0 ${tokens.spacing.md};
  line-height: 1.2;
  font-size: ${({ $level }) => {
    const sizes = { 1: tokens.typography.size3xl, 2: tokens.typography.size2xl, 3: tokens.typography.sizeXl };
    return sizes[$level] || tokens.typography.size2xl;
  }};
`;

export function Heading({ level = 2, children, ...props }) {
  const Tag = `h${Math.min(Math.max(level, 1), 6)}`;
  return (
    <StyledHeading as={Tag} $level={level} {...props}>
      {children}
    </StyledHeading>
  );
}

export default Heading;
